export const INIT_STATE = { text_message_threads: null, settings: null };
